import React from 'react';

const blueHeart = '/emoji/1FA75.svg';
const emptyHeart = '/emoji/1F90D.svg';

export default function Votestars({
  value = 0,
  onVote = () => {},
  avg = 0,
  songId,
  disabled = false,
}) {
  return (
    <div className="relative w-[64px] h-5">
      <div
        className="absolute inset-0 bg-gray-200 rounded"
        style={{ width: `${(avg || 0) * 20}%` }}
      ></div>
      <div className="relative z-10 flex flex-row items-center">
        {Array.from({ length: 5 }, (_, i) => (
          <span
            key={i}
            className={
              disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
            }
            onClick={disabled ? undefined : () => onVote(songId, i + 1)}
            title={disabled ? 'Log in to vote' : undefined}
          >
            <img
              src={i < value ? blueHeart : emptyHeart}
              alt={i < value ? 'Blue heart' : 'Empty heart'}
              style={{ width: 16, height: 16, verticalAlign: 'middle' }}
              draggable={false}
            />
          </span>
        ))}
      </div>
    </div>
  );
}
